var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "day m-1" }, [
    _c("div", { staticClass: "day-header" }, [
      _c(
        "span",
        {
          staticClass: "day-number",
          class: { "other-day": _vm.isCurrentMonth },
        },
        [_vm._v(_vm._s(_vm.dayDate))]
      ),
    ]),
    _c(
      "div",
      { staticClass: "day-body" },
      [
        _vm._t(
          "body",
          function () {
            return [_c("span", [_vm._v(_vm._s(_vm.dayDate))])]
          },
          { cell: _vm.cell }
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }